export default "__VITE_ASSET__93ac9b54__"